var map = {
	"./BeastFeast2.png": 1665,
	"./FetchRanch1.png": 1066,
	"./FetchRanch2.png": 4327,
	"./FetchRanch3.png": 6770,
	"./LinkedIn_coral.png": 7993,
	"./NFWNew1.png": 9357,
	"./NFWNew2.png": 3597,
	"./NFWNew3.png": 3387,
	"./QnD1.png": 1810,
	"./QnD11.png": 6049,
	"./QnD2.png": 5109,
	"./QnD3.png": 2855,
	"./QnD4.png": 1912,
	"./circus1.png": 6852,
	"./circus2.png": 2791,
	"./circus3.png": 5990,
	"./copyText.png": 1735,
	"./discord_Icon.png": 3862,
	"./foowLevel3.png": 5480,
	"./foowLevel4.png": 9553,
	"./foowMenu.png": 4658,
	"./gitHub_Icon.png": 2988,
	"./logo.png": 6949,
	"./mail_Icon.png": 9735,
	"./mindre-bild2.png": 3097,
	"./naturensode1.png": 8401,
	"./naturensode2.png": 1858,
	"./naturensode3.png": 7322,
	"./titlescreenwulf.png": 8495,
	"./titlescreenwulf2.png": 4040,
	"./ttt_1.png": 4089,
	"./ttt_2.png": 6318,
	"./ttt_3.png": 2704
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;